import React, { createContext, useContext } from "react"

import { FormContextValue } from "shared/ui/form/FormContext"

import { ProjectModel } from "features/project-management/types/ProjectModel"

export interface ProjectFormContextValue extends FormContextValue {
  isLoading?: boolean
  onCancel?: () => void
  model?: ProjectModel | null
}

const ProjectFormContext = createContext<ProjectFormContextValue | undefined>(
  undefined
)

export interface ProjectFormProviderProps {
  value: ProjectFormContextValue
  children: React.ReactNode
}

export const ProjectFormProvider = React.memo(
  ({ value, children }: ProjectFormProviderProps) => (
    <ProjectFormContext.Provider value={value}>
      {children}
    </ProjectFormContext.Provider>
  )
)

export function useProjectFormContext(): ProjectFormContextValue {
  const context = useContext(ProjectFormContext)
  if (!context) {
    throw new Error(
      "useProjectFormContext must be used within a ProjectFormProvider"
    )
  }
  return context
}
